//src/admin/pages/AdminAbandonedCarts.js
import React, { useEffect, useState, useContext } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import { getAdminAbandonedCarts, sendAbandonedCartEmail } from "../../services/adminAbandonedCarts.api";
import { buildAbandonedCartWhatsAppMessage } from "../../utils/whatsappMessages";
import { FaShoppingCart, FaSearch, FaRegCalendarAlt } from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import { FaEye, FaEnvelope } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import { deleteAbandonedCart } from "../../services/adminAbandonedCarts.api";
import { useNavigate } from "react-router-dom";
import { adminApiRequest } from "../../services/adminApi";
import { FiShoppingCart } from "react-icons/fi";
import { FiX } from "react-icons/fi";

function AdminAbandonedCarts() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [recoverMenu, setRecoverMenu] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const { lang } = useContext(AdminLanguageContext);

  const t = (en, ar) => (lang === "AR" ? ar : en);

  const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");
  const perms = JSON.parse(localStorage.getItem("staffPermissions") || {});
  const isAdmin = adminUser.role === "admin";

  const canAccess = isAdmin || perms.can_manage_orders;

  const [sendingId, setSendingId] = useState(null);
  const [toast, setToast] = useState(null);

  const [search, setSearch] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);

  const [dateOverlayOpen, setDateOverlayOpen] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [sortOpen, setSortOpen] = useState(false);
  const [sortField, setSortField] = useState("date");
  const [sortDirection, setSortDirection] = useState("desc");

  const [customerOverlay, setCustomerOverlay] = useState(null);

  const [totalOverlay, setTotalOverlay] = useState(null);

  const hasCustomDate = Boolean(fromDate || toDate);

  const [selectedCarts, setSelectedCarts] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [showToast, setShowToast] = useState(false);

  const handleSendEmail = async (row) => {
  if (!row?.email) return; // ✅ ignore

  try {
    setSendingId(row.userId);
    await sendAbandonedCartEmail(row.userId);
     setRows(prev =>
   prev.map(r =>
     r.userId === row.userId ? { ...r, emailSent: true } : r
   )
 );
    setToast(lang === "AR" ? "تم إرسال البريد" : "Email sent");
setShowToast(true);
setTimeout(() => {
  setShowToast(false);
  setToast(null);
}, 3000);
  } catch (e) {
    setToast(lang === "AR" ? "فشل إرسال البريد" : "Failed to send email");
setShowToast(true);
setTimeout(() => {
  setShowToast(false);
  setToast(null);
}, 3000);
  } finally {
    setSendingId(null);
    setTimeout(() => setToast(null), 3000);
  }
};


  useEffect(() => {
  if (!canAccess) {
    setLoading(false);
    return;
  }

  getAdminAbandonedCarts()
    .then(setRows)
    .finally(() => setLoading(false));
}, [canAccess]);

useEffect(() => {
  setCurrentPage(1);
}, [search, fromDate, toDate]);

useEffect(() => {
  const handleClick = (e) => {
    if (
      !e.target.closest(".customer-overlay") &&
      !e.target.closest(".customer-trigger") &&
      !e.target.closest(".total-overlay") &&
      !e.target.closest(".total-trigger") &&
      !e.target.closest(".recover-menu") &&
      !e.target.closest(".recover-trigger")
    ) {
      setCustomerOverlay(null);
      setTotalOverlay(null);
      setRecoverMenu(null);
    }
  };

  if (customerOverlay || totalOverlay || recoverMenu) {
    document.addEventListener("mousedown", handleClick);
  }

  return () => document.removeEventListener("mousedown", handleClick);
}, [customerOverlay, totalOverlay, recoverMenu]);

useEffect(() => {
  const handleClick = (e) => {
    if (
      !e.target.closest(".sort-overlay") &&
      !e.target.closest(".sort-button")
    ) {
      setSortOpen(false);
    }
  };

  if (sortOpen) {
    document.addEventListener("mousedown", handleClick);
  }

  return () => document.removeEventListener("mousedown", handleClick);
}, [sortOpen]);

const handleSendWhatsApp = async (row) => {
  if (!row?.phone) return;

  const phone = row.phone.replace(/\D/g, "");
  const msg = buildAbandonedCartWhatsAppMessage({
    name: row.name,
    cartLink: row.cartLink,
  });

  const url = `https://wa.me/${phone}?text=${msg}`;
  window.open(url, "_blank");

  try {
    await adminApiRequest(`/admin/abandoned-carts/${row.userId}/whatsapp-sent`, {
  method: "POST",
});

    // ✅ update UI instantly
    setRows(prev =>
      prev.map(r =>
        r.userId === row.userId ? { ...r, whatsappSent: true } : r
      )
    );
  } catch {}
};

const filtered = rows.filter((r) => {
        const s = search.toLowerCase();

        const matchesSearch =
          r.name?.toLowerCase().includes(s) ||
          r.phone?.toLowerCase().includes(s) ||
          r.email?.toLowerCase().includes(s);

        const cartDate = new Date(r.cartUpdatedAt);

        const matchesFrom =
          fromDate ? cartDate >= new Date(fromDate) : true;

        const matchesTo =
          toDate
            ? cartDate <= new Date(toDate + "T23:59:59")
            : true;

        return matchesSearch && matchesFrom && matchesTo;
      });

const sorted = [...filtered].sort((a, b) => {
  if (sortField === "date") {
    const d1 = new Date(a.cartUpdatedAt);
    const d2 = new Date(b.cartUpdatedAt);
    return sortDirection === "asc" ? d1 - d2 : d2 - d1;
  }

  if (sortField === "customer") {
  const nameA = String(a.name || "");
  const nameB = String(b.name || "");

  return sortDirection === "asc"
    ? nameA.localeCompare(nameB)
    : nameB.localeCompare(nameA);
}

  return 0;
});

const totalPages = Math.max(1, Math.ceil(sorted.length / rowsPerPage));

const paginatedRows = sorted.slice(
  (currentPage - 1) * rowsPerPage,
  currentPage * rowsPerPage
);

const formatDateTime = (dateString) => {
  const d = new Date(dateString);

  const datePart = d.toLocaleDateString(lang === "AR" ? "ar-EG" : "en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  const timePart = d.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return lang === "AR"
  ? `${datePart} - ${timePart}`
  : `${datePart} at ${timePart}`;
};

const toggleCartSelection = (id) => {
  setSelectedCarts((prev) =>
    prev.includes(id)
      ? prev.filter((c) => c !== id)
      : [...prev, id]
  );
};

const toggleSelectAll = () => {
  if (selectedCarts.length === paginatedRows.length) {
    setSelectedCarts([]);
  } else {
    setSelectedCarts(paginatedRows.map((r) => r.userId));
  }
};

const confirmDelete = async () => {
  try {
    await deleteAbandonedCart(deleteId);

    setRows(prev => prev.filter(r => r.userId !== deleteId));

    setDeleteId(null);

    setToast(t("Abandoned cart deleted","تم حذف السلة المتروكة"));
setShowToast(true);
setTimeout(() => {
  setShowToast(false);
  setToast(null);
}, 3000);

  } catch (err) {
    console.error(err);
  }
};

const confirmBulkDelete = async () => {
  try {

    await Promise.all(
      selectedCarts.map(id => deleteAbandonedCart(id))
    );

    setRows(prev =>
      prev.filter(r => !selectedCarts.includes(r.userId))
    );

    setSelectedCarts([]);
    setDeleteId(null);

    setToast(t("Abandoned cart deleted","تم حذف السلة المتروكة"));
setShowToast(true);
setTimeout(() => {
  setShowToast(false);
  setToast(null);
}, 3000);

  } catch (err) {
    console.error(err);
  }
};

  return (
    <div className="flex bg-[#f1f1f1] min-h-screen">
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className={`flex-1 ${lang === "EN" ? "lg:ml-64" : ""}`}>
        <AdminHeader setIsOpen={setIsOpen} />

       <main
className={`p-4 sm:p-6 animate-fadeSlide ${lang==="AR" ? "rtl text-right" : ""}`}
>
  {!canAccess ? (
    <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
      <p className="text-red-700 font-semibold">
        {lang === "AR"
          ? "غير مصرح لك بالوصول إلى هذه الصفحة"
          : "You are not allowed to access this page"}
      </p>
    </div>
  ) : (
  <>
    <div className="flex items-center justify-between mb-5">

<div className="mx-1 flex items-center gap-2">

<div className="relative flex items-center justify-center w-6 h-6">
  <FiShoppingCart className="text-gray-900 text-[22px]" />
  <FiX className="absolute text-[12px] text-gray-900 mb-0.5 ml-1" />
</div>

<div className="flex items-baseline gap-2">
<h1 className="text-[18px] font-semibold text-gray-900">
{t("Abandoned Checkouts","عمليات شراء متروكة")}
</h1>
</div>

</div>

</div>

         <div className="
                    hidden md:block
                    bg-white
                    border border-[#e3e3e3]
                    rounded-[14px]
                    overflow-visible
                    shadow-[0_12px_32px_rgba(0,0,0,0.10),0_2px_6px_rgba(0,0,0,0.06)]
                    ">

                    {/* TABLE TOP HEADER */}
<div className="relative flex items-center justify-between px-4 py-2 border-b border-[#e3e3e3] bg-white rounded-t-[14px] overflow-visible">

{/* SORT OVERLAY */}
{sortOpen && (
<div
className={`sort-overlay absolute top-full mt-1 w-47 bg-white border border-gray-200 rounded-xl shadow-[0_30px_30px_rgba(0,0,0,0.15)] z-50 animate-sortOverlay ${
  lang === "AR" ? "left-0" : "right-3"
}`}
>

<div className="px-4 pt-4 text-xs font-semibold uppercase tracking-wide">
{t("Sort by","ترتيب حسب")}
</div>

<div className="mt-1 text-sm">

<label className={`flex items-center gap-3 px-3 py-1 rounded-md hover:bg-gray-100 cursor-pointer ${sortField==="customer" ? "bg-gray-100 font-medium":""}`}>
<input
type="radio"
checked={sortField==="customer"}
onChange={()=>setSortField("customer")}
className="w-4 h-4 accent-gray-800"
/>
{t("Customer","العميل")}
</label>

<label className={`flex items-center gap-3 px-3 py-1 rounded-md hover:bg-gray-100 cursor-pointer ${sortField==="date" ? "bg-gray-100 font-medium":""}`}>
<input
type="radio"
checked={sortField==="date"}
onChange={()=>setSortField("date")}
className="w-4 h-4 accent-gray-800"
/>
{t("Last update","آخر تحديث")}
</label>

</div>

<div className="my-2 border-t border-gray-300"></div>

<div className="px-1 pb-1 flex flex-col">

<button
onClick={()=>{
setSortDirection("asc");
setSortOpen(false);
}}
className="flex items-center gap-2 px-3 py-2 text-sm rounded-md hover:bg-gray-100"
>
↑ {t("Ascending","تصاعدي")}
</button>

<button
onClick={()=>{
setSortDirection("desc");
setSortOpen(false);
}}
className="flex items-center gap-2 px-3 py-2 text-sm rounded-md hover:bg-gray-100"
>
↓ {t("Descending","تنازلي")}
</button>

{sortField === "date" && (
  hasCustomDate ? (
    <button
      onClick={() => {
        setFromDate("");
        setToDate("");
        setSortOpen(false);
      }}
      className="
      flex items-center gap-2
      px-3 py-2
      text-sm
      rounded-md
      hover:bg-gray-100
      transition
      "
    >
      ↺ {t("Reset date","إعادة ضبط التاريخ")}
    </button>
  ) : (
    <button
      onClick={() => {
        setDateOverlayOpen(true);
        setSortOpen(false);
      }}
      className="
      flex items-center gap-2
      px-3 py-2
      text-sm
      rounded-md
      hover:bg-gray-100
      transition
      "
    >
      <FaRegCalendarAlt className="text-gray-900 text-sm" />
      {t("Custom date","تاريخ مخصص")}
    </button>
  )
)}

</div>

</div>
)}

{/* LEFT SIDE */}
{!searchOpen ? (

<div className="flex items-center gap-1">

{/* EMPTY like orders but without status filters */}

</div>

) : (

/* SHOPIFY SEARCH BAR */
<div className="flex items-center gap-3 w-full">

<div className="
flex items-center justify-between
flex-1
h-8
px-3
bg-white
border border-gray-300
rounded-lg
shadow-sm
focus-within:border-gray-500
focus-within:ring-2
focus-within:ring-gray-200
transition
">

<div className="flex items-center gap-2 flex-1">

<FaSearch className="text-gray-400 text-sm"/>

<input
autoFocus
type="text"
value={search}
onChange={(e)=>setSearch(e.target.value)}
placeholder={t("Search customer...","ابحث عن عميل")}
className="flex-1 outline-none text-sm"
/>

</div>

<div className="flex items-center gap-2">

{loading && (
  <div className="flex items-center gap-2 mr-2">
    <div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
    <span className="text-xs text-gray-500">
      {t("Loading","جارٍ التحميل")}
    </span>
  </div>
)}

<button
onClick={()=>{
setSearch("");
setSearchOpen(false);
}}
className="
w-5 h-5
flex items-center justify-center
rounded-full
border border-gray-500
text-gray-500
hover:bg-gray-100
transition
"
>
✕
</button>

</div>

</div>

{/* CANCEL BUTTON */}
<button
onClick={()=>{
setSearch("");
setSearchOpen(false);
}}
className="
px-3 h-9
mx-1
bg-white
border border-gray-300
rounded-lg
shadow-sm
hover:bg-gray-50
text-sm font-medium
"
>
{t("Cancel","إلغاء")}
</button>

</div>

)}

{/* RIGHT TOOL BUTTONS */}
<div className="flex items-center gap-2">

{loading && (
<div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin mr-2"></div>
)}

{selectedCarts.length > 0 && (
<button
onClick={() => setDeleteId("bulk")}
className="
flex items-center justify-center
w-9 h-9
bg-white
border border-gray-300
rounded-lg
shadow-[0_1px_0_rgba(0,0,0,0.05),0_2px_4px_rgba(0,0,0,0.06)]
hover:bg-gray-50
transition
"
>
<FaTrash className="text-gray-600 text-sm" />
</button>
)}

{/* SEARCH */}
{!searchOpen && (
<button
onClick={()=>setSearchOpen(true)}
className="
flex items-center justify-center gap-1
px-2 h-9
bg-white
border border-gray-300
rounded-lg
shadow-[0_1px_0_rgba(0,0,0,0.05),0_2px_4px_rgba(0,0,0,0.06)]
hover:bg-gray-50
active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.08)]
transition
">

<FaSearch className="text-gray-600 text-sm"/>

<svg width="14" height="14" viewBox="0 0 20 20" fill="none">
<path
d="M3 5H17M6 10H14M9 15H11"
stroke="#4B5563"
strokeWidth="1.8"
strokeLinecap="round"
/>
</svg>

</button>
)}

{/* SORT */}
<button
onClick={()=>setSortOpen(v=>!v)}
className="
sort-button
flex items-center justify-center
w-9 h-9
bg-white
border border-gray-300
rounded-lg
shadow-[0_1px_0_rgba(0,0,0,0.05),0_2px_4px_rgba(0,0,0,0.06)]
hover:bg-gray-50
active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.08)]
transition
">
<span className="text-gray-600 text-sm">⇅</span>
</button>

</div>

</div>


                    {/* TABLE CONTENT WRAPPER */}
                    <div className="rounded-b-[14px] overflow-visible">

                    {/* HEADER 2 */}
                    <table dir={lang==="AR" ? "rtl" : "ltr"} className="min-w-full">

                    <thead className="bg-[#f6f6f7] text-[#6d7175] text-[13px] font-medium">

                    <tr>

                    <th dir="ltr" className="px-3 py-1.5 text-center">
                    <input
                    type="checkbox"
                    checked={
                    selectedCarts.length === paginatedRows.length &&
                    paginatedRows.length > 0
                    }
                    onChange={toggleSelectAll}
                    className="w-4 h-4 accent-gray-800 cursor-pointer"
                    />
                    </th>

                    <th className="px-4 py-1.5 text-start">{t("Customer","العميل")}</th>
                    <th className="px-4 py-1.5 text-start">{t("Total","الإجمالي")}</th>
                    <th className="px-4 py-1.5 text-start">{t("Last Update","آخر تحديث")}</th>
<th className="px-4 py-1.5 text-start">{t("WhatsApp","واتساب")}</th>
<th className="px-4 py-1.5 text-start">{t("Email","بريد")}</th>
<th className="px-4 py-1.5 text-start">{t("Link","الرابط")}</th>
                    <th className="px-4 py-1.5 text-start">{t("Actions","الإجراءات")}</th>

                    </tr>

                    </thead>

                    <tbody>

                    {loading ? (
  [...Array(6)].map((_, i) => (
    <tr key={i} className="animate-pulse">
      <td className="px-3 py-2">
        <div className="w-4 h-4 bg-gray-200 rounded"></div>
      </td>

      <td className="px-4 py-2">
        <div className="h-3 w-28 bg-gray-200 rounded"></div>
      </td>

      <td className="px-4 py-2">
        <div className="h-3 w-16 bg-gray-200 rounded"></div>
      </td>

      <td className="px-4 py-2">
        <div className="h-3 w-24 bg-gray-200 rounded"></div>
      </td>

      <td className="px-4 py-2">
        <div className="h-5 w-16 bg-gray-200 rounded-md"></div>
      </td>

      <td className="px-4 py-2">
        <div className="h-5 w-16 bg-gray-200 rounded-md"></div>
      </td>

      <td className="px-4 py-2">
        <div className="h-3 w-20 bg-gray-200 rounded"></div>
      </td>

      <td className="px-4 py-2">
        <div className="h-8 w-24 bg-gray-200 rounded-md"></div>
      </td>
    </tr>
  ))
) : sorted.length === 0 ? (
                    <tr>
  <td colSpan="8" className="py-12">
    <div className="flex flex-col items-center justify-center text-center">

      <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-3">
        <FaShoppingCart className="text-gray-400 text-lg" />
      </div>

      <p className="text-sm font-medium text-gray-900">
        {t("No abandoned carts","لا توجد سلات متروكة")}
      </p>

      <p className="text-xs text-gray-500 mt-1">
        {t(
          "Customers will appear here when they leave checkout",
          "ستظهر هنا السلات عند مغادرة العملاء لصفحة الدفع"
        )}
      </p>

    </div>
  </td>
</tr>
                    ) : (

                    paginatedRows.map((r,i)=>(

                   <tr
  key={i}
  onClick={() => navigate(`/admin/abandoned-carts/${r.userId}`)}
  className="
  border-b border-[#f1f1f1]
  hover:bg-[#f6f6f7]
  transition
  cursor-pointer
  "
>
<td
dir="ltr"
className="px-3 py-1.5 text-center"
onClick={(e)=>e.stopPropagation()}
>
<input
type="checkbox"
checked={selectedCarts.includes(r.userId)}
onChange={() => toggleCartSelection(r.userId)}
className="w-4 h-4 accent-gray-800 cursor-pointer"
/>
</td>

                    <td
className="customer-trigger group relative px-4 py-1.5 text-[13px] text-gray-800 cursor-pointer hover:bg-gray-200"
onClick={(e) => {
e.stopPropagation();
setCustomerOverlay(r.userId === customerOverlay?.id ? null : { ...r, id: r.userId });
}}
>

<div className="flex items-center gap-1 font-medium text-gray-900">

{r.name}

<span className="opacity-0 group-hover:opacity-100 transition text-gray-400">
<FiChevronDown className="text-[18px]" />
</span>

</div>

{customerOverlay?.id === r.userId && (

<div
className="
customer-overlay
absolute
left-0
top-full
mt-2
w-[270px]
bg-white
border border-gray-200
rounded-[14px]
shadow-[0_25px_60px_rgba(0,0,0,0.20)]
z-50
animate-sortOverlay
"
>

{/* CUSTOMER HEADER */}
<div className="px-4 pt-3 pb-2">

<div className="text-[15px] font-semibold text-gray-900 leading-tight">
{r.name}
</div>

{r.phone && (
<div className="text-[13px] text-blue-600 mt-[2px]">
{r.phone}
</div>
)}

{r.email && (
<div className="text-[12.5px] text-gray-500">
{r.email}
</div>
)}

</div>

{/* ORDERS COUNT */}
<div className="px-4 pb-3 text-[12px] text-gray-500">
{r.ordersCount ?? 0} {lang === "AR" ? "طلبات" : "orders"}
</div>

<div className="border-t border-gray-200"></div>

{/* VIEW CUSTOMER BUTTON */}
<div className="p-2">
<button
disabled={r.isGuest}
onClick={(e)=>{
  e.stopPropagation();
  if (r.isGuest) return;
  window.open(`/admin/customers/${r.userId}`, "_blank");
}}
className={`
w-full
flex items-center justify-center gap-2
h-[34px]
border border-gray-300
rounded-lg
text-[13px] font-medium
shadow-[0_1px_0_rgba(0,0,0,0.05),0_3px_6px_rgba(0,0,0,0.08)]
transition
${
  r.isGuest
    ? "bg-gray-100 text-gray-400 cursor-not-allowed"
    : "bg-[#f6f6f7] text-gray-800 hover:bg-gray-100 active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.12)]"
}
`}
>
  <FaEye className="text-[12px] text-gray-600"/>

  {r.isGuest
    ? t("Guest checkout", "طلب زائر")
    : t("View customer", "عرض العميل")}
</button>
</div>

</div>

)}

</td>

                    <td
                        className="total-trigger group relative px-4 py-1.5 text-[13px] text-gray-800 cursor-pointer hover:bg-gray-200"
                        onClick={(e)=>{
                        e.stopPropagation();
                        setTotalOverlay(r.userId === totalOverlay?.id ? null : { ...r, id: r.userId });
                        }}
                        >

                        {/* TOTAL PRICE */}
                        <div className="flex items-center gap-1 font-medium text-gray-900">

                        {(() => {
                        const total = r.cartItems.reduce((sum, it) => sum + (it.price || 0) * it.qty, 0);
                        return `$${total.toFixed(2)}`;
                        })()}

                        <span className="opacity-0 group-hover:opacity-100 transition text-gray-400">
                        <FiChevronDown className="text-[18px]" />
                        </span>

                        </div>

                        {/* TOTAL OVERLAY */}
                        {totalOverlay?.id === r.userId && (

                        <div
                        className="
                        total-overlay
                        absolute
                        left-0
                        top-full
                        mt-2
                        w-[270px]
                        bg-white
                        border border-gray-200
                        rounded-[14px]
                        shadow-[0_25px_60px_rgba(0,0,0,0.20)]
                        z-50
                        animate-sortOverlay
                        "
                        >

                        {/* TOTAL PRICE */}
                        <div className="px-4 pt-3 pb-2">

                        <div className="text-[15px] font-semibold text-gray-900">
                        {t("Total","الإجمالي")}
                        </div>

                        <div className="text-[13px] text-gray-600 mt-1">

                        {(() => {
                        const total = r.cartItems.reduce((sum, it) => sum + (it.price || 0) * it.qty, 0);
                        return `$${total.toFixed(2)}`;
                        })()}

                        </div>

                        </div>

                        {/* TOTAL ITEMS */}
                        <div className="px-4 pb-2 text-[12px] text-gray-500">

                        {r.cartItems.reduce((sum, it) => sum + it.qty, 0)} {t("items","عناصر")}

                        </div>

                        <div className="border-t border-gray-200"></div>

                        {/* ITEM IDS */}
                        <div className="px-4 py-2 text-[12px] text-gray-600 space-y-1">

                        {r.cartItems.map((it, idx) => (
                        <div key={idx}>
                        {t("ID","المعرف")}: {it.product_id}
                        </div>
                        ))}

                        </div>

                        </div>

                        )}

                        </td>

                    <td className="px-4 py-1.5 text-[13px] text-gray-800">
                    {formatDateTime(r.cartUpdatedAt)}
                    </td>
{/* WHATSAPP STATUS */}
<td className="px-4 py-1.5">
  <span
    className={`inline-flex items-center px-2 py-[2px] rounded-md text-[12px] font-medium
      ${
        r.whatsappSent
          ? "bg-green-100 text-green-700"
          : "bg-yellow-100 text-yellow-700"
      }`}
  >
    {r.whatsappSent
      ? t("Sent","تم الإرسال")
      : t("Not sent","لم يتم الإرسال")}
  </span>
</td>

{/* EMAIL STATUS */}
<td className="px-4 py-1.5">
  <span
    className={`inline-flex items-center px-2 py-[2px] rounded-md text-[12px] font-medium
      ${
        !r.email
          ? "bg-gray-100 text-gray-500"
          : r.emailSent
          ? "bg-green-100 text-green-700"
          : "bg-yellow-100 text-yellow-700"
      }`}
  >
    {!r.email
      ? t("unavailable","غير متوفر")
      : r.emailSent
      ? t("Sent","تم الإرسال")
      : t("Not sent","لم يتم الإرسال")}
  </span>
</td>
                    <td className="px-4 py-1.5 text-[13px]">
                    <a
                      href={r.cartLink}
                      target="_blank"
                      rel="noreferrer"
                      className="
                      inline-flex items-center gap-1
                      text-[13px] font-medium
                      text-gray-900
                      hover:text-black
                      transition
                      "
                      >
                      <FaEye className="text-[12px]" />
                      {t("Open Cart","فتح السلة")}
                      </a>
                    </td>

                    <td className="px-4 py-1.5">

<div className="relative inline-block text-left">

<button
onClick={(e)=>{
e.stopPropagation();
setRecoverMenu(recoverMenu === r.userId ? null : r.userId);
}}
className="
recover-trigger
flex items-center gap-2
h-[32px]
px-3
text-[13px] font-medium
bg-white
border border-gray-300
rounded-md
shadow-[0_1px_0_rgba(0,0,0,0.05)]
hover:bg-gray-50
transition
"
>
{t("Send recovery","إرسال الاسترجاع")}
<FiChevronDown className="text-[14px]"/>
</button>

{recoverMenu === r.userId && (

<div
className="
recover-menu
absolute right-0 mt-2
w-[180px]
bg-white
border border-gray-200
rounded-[12px]
shadow-[0_25px_60px_rgba(0,0,0,0.18)]
z-50
overflow-hidden
animate-sortOverlay
"
>

<button
onClick={(e)=>{
e.stopPropagation();
setRecoverMenu(null);
handleSendEmail(r);
}}
disabled={!r.email}
className="
flex items-center gap-2
w-full
px-4 py-2
text-[13px]
text-gray-800
hover:bg-gray-50
transition
disabled:opacity-40
"
>
<FaEnvelope className="text-[12px]" />
{t("Send Email","إرسال بريد")}
</button>

<button
onClick={(e)=>{
e.stopPropagation();
setRecoverMenu(null);
handleSendWhatsApp(r);
}}
disabled={!r.phone}
className="
flex items-center gap-2
w-full
px-4 py-2
text-[13px]
text-gray-800
hover:bg-gray-50
transition
disabled:opacity-40
"
>
<FaWhatsapp className="text-[13px]" />
{t("Send WhatsApp","إرسال واتساب")}
</button>

</div>

)}

</div>

</td>

                    </tr>

                    ))

                    )}

                    </tbody>

                      <tfoot>
                      <tr className="bg-[#f6f6f7] border-t border-[#e3e3e3] rounded-b-[14px]">
                      <td colSpan="8" className="px-4 py-1 rounded-b-[14px] overflow-hidden">

                      <div className={`flex items-center justify-between text-sm text-gray-600 ${lang === "AR" ? "flex-row-reverse" : ""}`}>

                      {/* CART COUNT */}
                      <span className="text-gray-500 text-sm">
                      {filtered.length} {lang === "AR" ? "سلات متروكة" : "Abandoned carts"}
                      </span>

                      {/* PAGINATION */}
                      <div className="flex items-center gap-0.5">

                      <button
                      onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                      disabled={currentPage === 1}
                      className={`w-7 h-7 flex font-bold items-center justify-center rounded-md border bg-gray-200
                      ${currentPage === 1
                        ? "opacity-40 cursor-not-allowed"
                        : "hover:bg-gray-300"}
                      `}
                      >
                      {"<"}
                      </button>

                      <button
                      onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                      disabled={currentPage === totalPages}
                      className={`w-7 h-7 flex items-center font-bold justify-center rounded-md border bg-gray-200
                      ${currentPage === totalPages
                        ? "opacity-40 cursor-not-allowed"
                        : "hover:bg-gray-300"}
                      `}
                      >
                      {">"}
                      </button>

                      <span className="mx-2 text-gray-600 font-bold">
                      {currentPage}-{totalPages}
                      </span>

                      </div>

                      </div>

                      </td>
                      </tr>
                      </tfoot>

                      </table>
                   </div>
                    </div>

          {/* MOBILE VIEW */}
<div className="md:hidden pt-1 pb-2">
  {/* MOBILE SEARCH */}
<div className="md:hidden px-4 mb-3">
  <div className="flex items-center gap-2 bg-white border border-gray-300 rounded-lg px-3 h-10 shadow-sm">
    <FaSearch className="text-gray-400 text-sm" />

    <input
      type="text"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      placeholder={t("Search customer...","ابحث عن عميل")}
      className="flex-1 outline-none text-sm"
    />

    {search && (
      <button
        onClick={() => setSearch("")}
        className="text-gray-400 hover:text-gray-600"
      >
        ✕
      </button>
    )}
  </div>
</div>
  {loading ? (
  [...Array(4)].map((_, i) => (
    <div
      key={i}
      className="bg-white rounded-xl p-4 mx-4 mb-3 animate-pulse"
    >
      <div className="h-4 w-32 bg-gray-200 rounded mb-2"></div>
      <div className="h-3 w-24 bg-gray-200 rounded mb-2"></div>

      <div className="flex gap-2 mt-3">
        <div className="h-5 w-20 bg-gray-200 rounded"></div>
        <div className="h-5 w-20 bg-gray-200 rounded"></div>
      </div>

      <div className="h-4 w-24 bg-gray-200 rounded mt-4"></div>
    </div>
  ))
) : filtered.length === 0 ? (
    <div className="bg-white p-6 mx-4 rounded-xl shadow text-center">

  <div className="w-12 h-12 mx-auto rounded-full bg-gray-100 flex items-center justify-center mb-3">
    <FaShoppingCart className="text-gray-400" />
  </div>

  <p className="text-sm font-medium text-gray-900">
    {t("No abandoned carts","لا توجد سلات متروكة")}
  </p>

  <p className="text-xs text-gray-500 mt-1">
    {t(
      "Customers will appear here when they leave checkout",
      "ستظهر هنا السلات عند مغادرة العملاء لصفحة الدفع"
    )}
  </p>

</div>
  ) : (
    paginatedRows.map((r, i) => (
      <div
  key={i}
  className="
  bg-white
  rounded-[14px]
  border border-[#e3e3e3]
  shadow-[0_6px_18px_rgba(0,0,0,0.08)]
  p-4
  mx-4
  mb-3
  relative
"
>

{/* TOP RIGHT ACTIONS */}
<div className="absolute top-3 right-3 flex items-center gap-2">

  {/* VIEW */}
  <button
    onClick={(e) => {
      e.stopPropagation();
      navigate(`/admin/abandoned-carts/${r.userId}`);
    }}
    className="w-8 h-8 flex items-center justify-center rounded-md border bg-white hover:bg-gray-50"
  >
    <FaEye className="text-gray-600 text-sm" />
  </button>

  {/* DELETE */}
  <button
    onClick={(e) => {
      e.stopPropagation();
      setDeleteId(r.userId);
    }}
    className="w-8 h-8 flex items-center justify-center rounded-md border bg-white hover:bg-red-50"
  >
    <FaTrash className="text-red-500 text-sm" />
  </button>

</div>

{/* CUSTOMER */}
<div className="font-semibold text-gray-900 text-[16px]">
  {r.name}
</div>

{/* CONTACT */}
{r.phone && (
  <p className="text-[13px] text-gray-500 mt-1">
    {r.phone}
  </p>
)}

{r.email && (
  <p className="text-[13px] text-gray-600">
    {r.email}
  </p>
)}

{/* STATUS BADGES */}
<div className="flex gap-2 mt-2">

  {/* WHATSAPP */}
  <span className={`px-2 py-[2px] rounded-md text-[11px] font-medium
    ${r.whatsappSent ? "bg-green-100 text-green-700" : "bg-yellow-100 text-yellow-700"}
  `}>
    {r.whatsappSent
  ? t("WhatsApp sent ✓", "تم إرسال واتساب ✓")
  : t("WhatsApp", "واتساب")}
  </span>

  {/* EMAIL */}
  <span className={`px-2 py-[2px] rounded-md text-[11px] font-medium
    ${
      !r.email
        ? "bg-gray-100 text-gray-500"
        : r.emailSent
        ? "bg-green-100 text-green-700"
        : "bg-yellow-100 text-yellow-700"
    }
  `}>
    {!r.email
  ? t("Email unavailable", "البريد غير متوفر")
  : r.emailSent
  ? t("Email sent ✓", "تم إرسال البريد ✓")
  : t("Email", "بريد")}
  </span>

</div>

<div className="border-t border-gray-200 my-3"></div>

{/* TOTAL (instead of items) */}
<div className="text-[14px] font-semibold text-gray-900">
  {t("Total","الإجمالي")}:
  <span className="ml-2">
    {(() => {
      const total = r.cartItems.reduce((sum, it) => sum + (it.price || 0) * it.qty, 0);
      return `$${total.toFixed(2)}`;
    })()}
  </span>
</div>

{/* DATE */}
<p className="text-[12px] text-gray-500 mt-2">
  {formatDateTime(r.cartUpdatedAt)}
</p>

{/* ACTION BUTTONS */}
<div className="flex gap-2 mt-3">

  <button
    onClick={(e) => {
      e.stopPropagation();
      handleSendEmail(r);
    }}
    disabled={!r.email || sendingId === r.userId}
    className={`flex-1 px-3 py-2 rounded-lg text-[13px] font-medium transition
    ${!r.email
      ? "bg-gray-200 text-gray-500"
      : "bg-[#202223] text-white hover:bg-black"}
    `}
  >
    {sendingId === r.userId
  ? "..."
  : t("Email", "بريد")}
  </button>

  <button
    onClick={(e) => {
      e.stopPropagation();
      handleSendWhatsApp(r);
    }}
    disabled={!r.phone}
    className={`flex-1 px-3 py-2 rounded-lg text-[13px] font-medium transition
    ${!r.phone
      ? "bg-gray-200 text-gray-500"
      : "bg-white border border-gray-300 text-gray-800 hover:bg-gray-50"}
    `}
  >
    {t("WhatsApp", "واتساب")}
  </button>

</div>

</div>
      
    ))
  )}
  {/* MOBILE PAGINATION */}
<div className="md:hidden px-4 py-3 flex items-center justify-between text-sm text-gray-600">

  <span className="text-gray-500">
    {filtered.length} {t("Abandoned carts","سلات متروكة")}
  </span>

  <div className="flex items-center gap-1">

    <button
      onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
      disabled={currentPage === 1}
      className={`w-8 h-8 flex items-center justify-center rounded-md border bg-gray-200
        ${currentPage === 1 ? "opacity-40" : "hover:bg-gray-300"}
      `}
    >
      {"<"}
    </button>

    <span className="px-2 font-semibold">
      {currentPage}/{totalPages}
    </span>

    <button
      onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
      disabled={currentPage === totalPages}
      className={`w-8 h-8 flex items-center justify-center rounded-md border bg-gray-200
        ${currentPage === totalPages ? "opacity-40" : "hover:bg-gray-300"}
      `}
    >
      {">"}
    </button>

  </div>
</div>
</div>


          </>
           )}

           {dateOverlayOpen && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

    <div className="w-[360px] bg-white border border-gray-200 rounded-[18px] shadow-[0_30px_60px_rgba(0,0,0,0.16)] overflow-hidden animate-sortOverlay">

      <div className="px-5 py-4 bg-[#f6f6f7] border-b border-gray-200">
        <h3 className="text-[15px] font-semibold text-gray-800">
          {t("Custom date range","نطاق تاريخ مخصص")}
        </h3>
      </div>

      <div className="p-5 space-y-4">

        <div>
          <label className="block text-xs font-semibold text-gray-500 mb-2 uppercase tracking-wide">
            {t("From","من")}
          </label>

          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="w-full h-[42px] px-3 border border-gray-300 rounded-[12px]"
          />
        </div>

        <div>
          <label className="block text-xs font-semibold text-gray-500 mb-2 uppercase tracking-wide">
            {t("To","إلى")}
          </label>

          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            className="w-full h-[42px] px-3 border border-gray-300 rounded-[12px]"
          />
        </div>

      </div>

      <div className="px-5 py-4 bg-[#f6f6f7] border-t border-gray-200 flex justify-end gap-3">

        <button
          onClick={() => setDateOverlayOpen(false)}
          className="h-[38px] px-4 bg-white border border-gray-300 rounded-[10px]"
        >
          {t("Cancel","إلغاء")}
        </button>

        <button
          onClick={() => setDateOverlayOpen(false)}
          className="h-[38px] px-4 bg-[#202223] text-white rounded-[10px]"
        >
          {t("Apply","تطبيق")}
        </button>

      </div>

    </div>
  </div>
)}

{deleteId !== null && (
<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">

<div className="
w-[380px]
bg-white
border border-gray-200
rounded-[14px]
shadow-[0_20px_60px_rgba(0,0,0,0.15)]
overflow-hidden
animate-sortOverlay
">

<div className="flex items-center gap-3 px-5 py-4 border-b border-gray-200 bg-[#f6f6f7]">

<div className="
flex items-center justify-center
w-9 h-9
rounded-full
bg-red-50
border border-red-200
">
<FaTrash className="text-red-600 text-sm"/>
</div>

<h2 className="text-[15px] font-semibold text-gray-800">
{t("Delete abandoned cart?","هل تريد حذف السلة المتروكة؟")}
</h2>

</div>

<div className="px-5 py-5 text-sm text-gray-600">
{deleteId === "bulk"
  ? t(
      "You are about to delete multiple carts. This action cannot be undone.",
      "أنت على وشك حذف عدة سلات. لا يمكن التراجع عن هذا الإجراء."
    )
  : t(
      "This action cannot be undone.",
      "لا يمكن التراجع عن هذا الإجراء."
    )}
</div>

<div className="flex justify-end gap-3 px-5 py-4 border-t border-gray-200 bg-[#f6f6f7]">

<button
onClick={() => setDeleteId(null)}
className="
h-[36px] px-4
bg-white
border border-gray-300
rounded-lg
text-sm font-medium text-gray-900
hover:bg-gray-50
transition
"
>
{t("Cancel","إلغاء")}
</button>

<button
onClick={()=>{
if(deleteId === "bulk"){
confirmBulkDelete();
}else{
confirmDelete();
}
}}
className="
h-[36px] px-4
bg-red-600
text-white
rounded-lg
text-sm font-medium
hover:bg-red-700
transition
"
>
{t("Delete","حذف")}
</button>

</div>

</div>
</div>
)}

       
{showToast && (
<div className="fixed bottom-6 right-6 z-[9999] animate-fadeSlide">

<div className="
flex items-center gap-3
px-4 py-3
bg-white
border border-gray-200
rounded-[12px]
shadow-[0_10px_30px_rgba(0,0,0,0.12)]
">

<div className="
flex items-center justify-center
w-7 h-7
rounded-full
bg-green-100
">
<span className="text-green-700 text-sm">✓</span>
</div>

<div className="text-sm text-gray-800 font-medium">
{toast || t("Abandoned cart deleted","تم حذف السلة المتروكة")}
</div>

</div>

</div>
)}

        </main>
      </div>
    </div>
  );
}

export default AdminAbandonedCarts;
